import { Component, inject, Input, OnInit } from '@angular/core';
import {
  LargedTuileComponent,
  TuileButtonProps,
} from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';
import { P0003601ProgrammeFiltrationAuto } from '../../../Enum/P0003601ProgrammeFiltrationAuto';
import { P0003601EnSavoirPlusComponent } from '../../../EnSavoirPlus/p0003601-en-savoir-plus/p0003601-en-savoir-plus.component';
import { ModalController } from '@ionic/angular/standalone';
import { P0003601SpeedChoiceComponent } from '../../../Component/p0003601-speed-choice/p0003601-speed-choice.component';

@Component({
  selector: 'app-p0003601-card-filtration-controle',
  templateUrl: './p0003601-card-filtration-controle.component.html',
  styleUrls: ['./p0003601-card-filtration-controle.component.scss'],
  imports: [LargedTuileComponent, TranslatePipe, SmallTuileComponent],
})
export class P0003601CardFiltrationControleComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  private modalController = inject(ModalController);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  getStatus() {
    return this.actionStack!.getValue('fvsSVitesseFiltration') == 0
      ? 'P0003601.card.status.stop'
      : this.actionStack!.getValue('fvsSVitesseFiltration') == 1
        ? 'P0003601.card.status.v1'
        : this.actionStack!.getValue('fvsSVitesseFiltration') == 2
          ? 'P0003601.card.status.v2'
          : 'P0003601.card.status.max';
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  buttons: TuileButtonProps[] = [
    {
      title: 'P0003601.card.state.filtration.status.off',
      icon: 'fa-kit fa-picto-off',
      color: 'color-red',
      status: 'inactive',
    },
    {
      title: 'P0003601.filtration.controle.fonctionnement.manuel',
      icon: '',
      color: 'color-green',
      status: 'active',
      onPress: () => {
        this.openManual().finally(() => {});
      },
    },
    {
      title: 'P0003601.card.state.filtration.status.auto',
      icon: 'fa-kit fa-picto-programme',
      color: 'color-orange',
      status: 'active',
    },
  ];

  getButtons(): TuileButtonProps[] {
    const vitesseManuelle =
      this.actionStack!.getValue('fvsCVitesseManuelle') ?? 0;

    let res = 'fa-kit fa-vs-v1';

    if (vitesseManuelle === 1) {
      res = 'fa-kit fa-vs-v1';
    } else if (vitesseManuelle === 2) {
      res = 'fa-kit fa-vs-v2';
    } else if (vitesseManuelle === 3) {
      res = 'fa-kit fa-vs-max';
    }

    this.buttons[1].icon = res;

    return this.buttons;
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.FILTRATION_VS,
      FunctionOnglet.PARAMETRE_REGLAGE,
      this.translateService.instant('dashboard.filtrationvs'),
    );
  }

  async openManual() {
    const modal = await this.modalController.create({
      component: P0003601SpeedChoiceComponent,
      componentProps: {
        value: this.actionStack!.getValue('fvsCVitesseManuelle') ?? 0,
      },
      cssClass: 'dynamic-height',
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Controle,
        'fvsCVitesseManuelle',
        data.value,
      );
      this.actionStack!.commit();
    }
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003601ProgrammeFiltrationAuto =
    P0003601ProgrammeFiltrationAuto;
}
